import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";
import { useGetAllAccountsQuery } from "../../../../store/api/itemtaxapi";
import { useGetItemTaxTemplatesQuery, useGetTaxcategoryQuery } from "../../../../store/api/gsthsn";

const Table = ({ taxes, setTaxes, detaildata }) => {
    const [accountOptions, setAccountOptions] = useState([]);
    const createNewRow = () => ({
        type: "",
        account_head: "",
        tax_rate: "",
        amount: "",
        description: ""
    });

    const [rows, setRows] = useState([createNewRow()]);

    const tableRef = useRef();
    const dropdownRef = useRef();
    const [rowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showDropdownIndex, setShowDropdownIndex] = useState(null);
    const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });

    const { data: accountData } = useGetAllAccountsQuery();

    useEffect(() => {
        if (accountData?.data) {
            setAccountOptions(accountData.data.map(item => ({ name: item.name })));
        }
    }, [accountData]);

    const taxOptions = [
        { "name": "Actual" },
        { "name": "On Net Total" },
        { "name": "On Previous Raw Amount" },
        { "name": "On Previous Row Total" },
        { "name": "On Item Quantity" }
    ];

    // Initialize rows with detaildata when component mounts or detaildata changes
    useEffect(() => {
        if (detaildata && detaildata.length > 0) {
            const initialRows = detaildata.map(item => ({
                type: item.charge_type || "",
                account_head: item.account_head || "",
                tax_rate: item.rate?.toString() || "",
                amount: item.tax_amount?.toString() || "",
                description: item.description || ""
            }));
            setRows(initialRows);
        }
    }, [detaildata]);

    useEffect(() => {
        const formattedTaxes = rows
            .filter(row =>
                row.type &&
                row.tax_rate !== "" &&
                row.amount !== ""
            )
            .map(row => ({
                charge_type: row.type,
                account_head: row.account_head || "Output Tax SGST - S",
                rate: parseFloat(row.tax_rate) || 0,
                tax_amount: parseFloat(row.amount) || 0,
                description: row.description || ""
            }));

        setTaxes(formattedTaxes);
    }, [rows]);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
    const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map((_, index) => index));
        } else {
            setSelectedRows([]);
        }
    };

    const toggleRowSelection = (index) => {
        setSelectedRows(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    const updateRow = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const handleAddRow = () => {
        setRows([...rows, createNewRow()]);
        const lastPage = Math.ceil((rows.length + 1) / rowsPerPage);
        if (currentPage !== lastPage) setCurrentPage(lastPage);
    };

    const handleDeleteSelectedRows = () => {
        const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
        setRows(updatedRows);
        setSelectedRows([]);
        const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
        if (currentPage > lastPage) setCurrentPage(lastPage);
    };

    const handleSelectOption = (rowIndex, selectedItem, field) => {
        const updatedRows = [...rows];
        updatedRows[rowIndex][field] = selectedItem.name;
        setRows(updatedRows);
        setShowDropdownIndex(null);
    };

    return (
        <div className="table-container">
            <table className="table table-bordered mb-1" ref={tableRef}>
                <thead className="tableHead1">
                    <tr>
                        <th style={{ width: '4%', textAlign: 'center' }}>S.No</th>
                        <th style={{ width: '120px' }}>Type</th>
                        <th style={{ width: '100px' }}>Account Head</th>
                        <th style={{ width: '100px' }}>Tax Rate</th>
                        <th style={{ width: '100px' }}>Amount</th>
                        <th style={{ width: '100px' }}>Description</th>
                        
                    </tr>
                </thead>
                <tbody>
                    {currentRows.map((row, index) => {
                        const globalIndex = indexOfFirstRow + index;
                        const showDropdown = showDropdownIndex === globalIndex &&
                            (focusedCell.field === 'type' || focusedCell.field === 'account_head');

                        return (
                            <tr key={globalIndex} style={{ height: '30px' }}>

                                <td style={{ textAlign: "center" }}>
                                    <span  disabled style={{ fontSize: '0.8rem' }}>{globalIndex + 1}</span>
                                </td>

                                {/* Type */}
                                <td className="p-0 position-relative">
                                    <input
                                        type="text"
                                        disabled
                                        className="form-control tableinput noborder"
                                        value={row.type}
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onFocus={() => {
                                            setShowDropdownIndex(globalIndex);
                                            setFocusedCell({ rowIndex: globalIndex, field: 'type' });
                                        }}
                                        onBlur={() => setTimeout(() => setShowDropdownIndex(null), 200)}
                                        onChange={(e) => updateRow(globalIndex, "type", e.target.value)}
                                    />
                                    {showDropdown && focusedCell.field === 'type' && (
                                        <div
                                            ref={dropdownRef}
                                            className="dropdown-menu show"
                                            style={{
                                                width: '100%',
                                                maxHeight: '200px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            {taxOptions
                                                .filter(t => t.name.toLowerCase().includes(row.type?.toLowerCase()))
                                                .map((option, i) => (
                                                    <button
                                                        key={i}
                                                        className="dropdown-item"
                                                        type="button"
                                                        style={{ fontSize: '0.8rem' }}
                                                        onClick={() => handleSelectOption(globalIndex, option, 'type')}
                                                    >
                                                        {option.name}
                                                    </button>
                                                ))}
                                        </div>
                                    )}
                                </td>

                                {/* Account Head */}
                                <td className="p-0 position-relative">
                                    <input
                                        type="text"
                                        disabled
                                        className="form-control tableinput noborder"
                                        value={row.account_head}
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onFocus={() => {
                                            setShowDropdownIndex(globalIndex);
                                            setFocusedCell({ rowIndex: globalIndex, field: 'account_head' });
                                        }}
                                        onBlur={() => setTimeout(() => setShowDropdownIndex(null), 200)}
                                        onChange={(e) => updateRow(globalIndex, "account_head", e.target.value)}
                                    />
                                    {showDropdown && focusedCell.field === 'account_head' && (
                                        <div
                                            ref={dropdownRef}
                                            className="dropdown-menu show"
                                            style={{
                                                width: '100%',
                                                maxHeight: '200px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            {accountOptions
                                                .filter(t => t.name.toLowerCase().includes(row.account_head?.toLowerCase()))
                                                .map((account, i) => (
                                                    <button
                                                        key={i}
                                                        className="dropdown-item"
                                                        type="button"
                                                        style={{ fontSize: '0.8rem' }}
                                                        onClick={() => handleSelectOption(globalIndex, account, 'account_head')}
                                                    >
                                                        {account.name}
                                                    </button>
                                                ))}
                                        </div>
                                    )}
                                </td>

                                {/* Tax Rate */}
                                <td className="p-0">
                                    <input
                                        type="number"
                                        disabled
                                        className="form-control tableinput noborder"
                                        value={row.tax_rate}
                                        placeholder="00.00"
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onChange={(e) => updateRow(globalIndex, "tax_rate", e.target.value)}
                                    />
                                </td>

                                {/* Amount */}
                                <td className="p-0">
                                    <input
                                        type="number"
                                        disabled
                                        className="form-control tableinput noborder"
                                        value={row.amount}
                                        placeholder="00.00"
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onChange={(e) => updateRow(globalIndex, "amount", e.target.value)}
                                    />
                                </td>

                                {/* Description */}
                                <td className="p-0">
                                    <input
                                        type="text"
                                        disabled
                                        className="form-control tableinput noborder"
                                        value={row.description}
                                        placeholder="Description"
                                        style={{ fontSize: '0.8rem', textAlign: 'center' }}
                                        onChange={(e) => updateRow(globalIndex, "description", e.target.value)}
                                    />
                                </td>

                               
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <div className="d-flex pb-2 justify-content-between align-items-center">
                {rows.length > 10 && (
                    <>
                        <div className="d-flex align-items-center centerpagination">
                            <Pagination
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                                pageSize={rowsPerPage}
                                totalrecords={rows.length}
                            />
                        </div>
                        <div className="d-flex">
                            <span className="px-2" style={{ color: '#270B79' }}>
                                Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
                            </span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Table;